import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as ep from '../api/endpoints';
import type { NotificationRow } from '../api/types';
import { PushToggle } from '../components/PushToggle';
import { Empty, ErrorBox, Loading } from '../components/ui';
import { formatDateTime } from '../lib/dates';

/** Herkesin bildirimleri: veresiye hatırlatmaları, mükerrer kararları, (yöneticiye) ay kapanışı. */
export function NotificationsScreen() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const q = useQuery({ queryKey: ['notifications'], queryFn: ep.notifications });
  const refresh = () => qc.invalidateQueries({ queryKey: ['notifications'] });
  const read = useMutation({ mutationFn: ep.readNotification, onSuccess: refresh });
  const readAll = useMutation({ mutationFn: ep.readAllNotifications, onSuccess: refresh });
  const unread = q.data?.filter((n) => !n.read_at).length ?? 0;

  function open(n: NotificationRow) {
    if (!n.read_at) read.mutate(n.id);
    const target = n.type === 'credit.due' && n.payload.receipt_id ? `/fis/${n.payload.receipt_id}` : n.url;
    if (target && target !== '/bildirimler') nav(target);
  }

  return (
    <div className="stack">
      <div className="page-head">
        <h1>Bildirimler</h1>
        <span className="spacer" />
        {unread > 0 && <button className="btn small" disabled={readAll.isPending} onClick={() => readAll.mutate()}>Tümünü okundu yap</button>}
      </div>
      <PushToggle />
      <ErrorBox error={q.error} />
      {!q.data ? <Loading /> : !q.data.length ? <Empty>Bildirim yok.</Empty> : (
        <div className="card"><ul className="list">
          {q.data.map((n) => (
            <li key={n.id}>
              <button type="button" className="item notif-item" onClick={() => open(n)}>
                <span className={`notif-dot ${n.read_at ? '' : 'on'}`} aria-hidden="true" />
                <span style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                  <span className={`notif-title ${n.read_at ? '' : 'title'}`}>{n.title}</span>
                  <span className="small muted notif-body">{n.body}</span>
                  <span className="small muted">{formatDateTime(n.created_at)}</span>
                </span>
              </button>
            </li>
          ))}
        </ul></div>
      )}
    </div>
  );
}
